<button type="button" class="btn btn-light round" (click)="click()"><i class="fas fa-times"></i></button>
